import type { LucideIcon } from "lucide-react";
import { ScanLine, Database, Bot, Workflow, Bug, FileSearch } from "lucide-react";

export interface ExpertiseArea {
  index: string;
  title: string;
  description: string;
  items: string[];
}

export const expertise: ExpertiseArea[] = [
  {
    index: "01",
    title: ".NET ENGINEERING",
    description: "Production-grade C# across web, services and desktop — from domain models to deployment.",
    items: ["C#", ".NET", "ASP.NET Core", "MVC", "Entity Framework", "REST APIs", "Windows Applications"],
  },
  {
    index: "02",
    title: "ENTERPRISE SYSTEMS",
    description: "Reliable systems that survive real operations: data, jobs, logging and integration.",
    items: ["Architecture", "SQL Server", "MySQL", "Background Jobs", "Logging", "Configuration", "Integrations"],
  },
  {
    index: "03",
    title: "AI ENGINEERING",
    description: "Applied AI inside engineering workflows — review, retrieval and assistance that ships.",
    items: ["LLMs", "OpenAI APIs", "RAG", "Vector Databases", "AI Code Review", "Prompt Engineering", "AI-assisted Development"],
  },
  {
    index: "04",
    title: "COMPUTER VISION",
    description: "Machine vision for inspection and industrial automation — from image to decision.",
    items: ["HALCON", "Image Processing", "Inspection Systems", "Machine Vision", "Industrial Automation"],
  },
  {
    index: "05",
    title: "TECHNICAL LEADERSHIP",
    description: "Clarity, standards and mentorship — turning individual effort into team output.",
    items: ["Architecture", "Code Reviews", "Mentoring", "Technical Planning", "Problem Solving", "Team Collaboration"],
  },
];

export const marqueeItems = [
  "C#",
  ".NET",
  "ASP.NET CORE",
  "SQL SERVER",
  "ENTITY FRAMEWORK",
  "HALCON",
  "OPENAI",
  "RAG",
  "GITHUB",
  "DOCKER",
  "GIT",
];

export interface LabExperiment {
  title: string;
  description: string;
  icon: LucideIcon;
}

export const labExperiments: LabExperiment[] = [
  {
    title: "AI CODE REVIEW",
    description: "Automated review agents that read diffs like a senior engineer.",
    icon: ScanLine,
  },
  {
    title: "RAG SYSTEMS",
    description: "Retrieval-augmented pipelines grounding LLMs in real codebases.",
    icon: Database,
  },
  {
    title: "LLM INTEGRATION",
    description: "Production LLM features wired into .NET services and APIs.",
    icon: Bot,
  },
  {
    title: "DEVELOPER AUTOMATION",
    description: "Scripts and tools that remove repeated engineering toil.",
    icon: Workflow,
  },
  {
    title: "AI-ASSISTED DEBUGGING",
    description: "Model-driven triage for stack traces and production logs.",
    icon: Bug,
  },
  {
    title: "DOCUMENT INTELLIGENCE",
    description: "Parsing and understanding unstructured operational documents.",
    icon: FileSearch,
  },
];
